// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-video[data-v-320788d8]{display:flex;flex-direction:column;align-items:center;justify-content:center}.block-video__description[data-v-320788d8]{margin:20px 0;color:var(--q4s-neutral-600)}", ""]);
// Exports
module.exports = exports;
